import React, { useEffect, useState } from "react";
import RightCheck from "../assets/icons/RightCheck.svg";
import RadioNonCheckedIcon from "../assets/icons/RadioNonCheckedIcon.svg";
import RadioCheckedBoxIcon from "../assets/icons/RadioCheckedBoxIcon.svg";

type checkProps = {
  title: string;
  icon?: React.ReactNode;
  type?: "check" | "radio";
  voice?: string;
  selected?: boolean;
  onSelect?: () => void;
};

export default function ContainerCheckBox({
  title,
  icon,
  type = "check",
  voice,
  selected = false,
  onSelect,
}: checkProps) {
  const [check, setCheck] = useState(selected);

  useEffect(() => {
    setCheck(selected);
  }, [selected]);

  const handleClick = () => {
    if (onSelect) {
      onSelect();
    } else {
      setCheck(!check);
    }
  };

  return (
    <button
      className={`flex justify-between bg-white w-full items-center rounded-lg px-4 py-2 border-2 ${
        check ? "border-[#6158E0]" : "border-white"
      }`}
      onClick={handleClick}
    >
      <div className="flex gap-4 items-center">
        {icon}
        <p className="font-medium text-base text-black">{title}</p>
      </div>
      <div className="flex items-center gap-3">
        {
          check && voice && type === "radio" &&
          <div>
              <p className="text-right text-[#0F0C18] text-xs font-medium tracking-tight">{voice}</p>
            <p className="text-[#9392A2] text-[10px] font-medium tracking-tight -mt-1">Long tap to change</p>
          </div>
        }
        {check &&
          (type === "check" ? (
            <img src={RightCheck} alt="RightCheck" />
          ) : (
            <img src={RadioCheckedBoxIcon} alt="RadioCheckedBoxIcon" />
          ))}
        {!check && type !== "check" && (
          <img src={RadioNonCheckedIcon} alt="RadioNonCheckedIcon" />
        )}
      </div>
    </button>
  );
}
